import React, { Component } from 'react'
import style from './index.module.less'
import cls from 'classnames'
import { EditOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react'
import { isSiDaMember } from '@util'
import {
  MENU_ALL,
  MENU_NOT_CLASSIFY
} from '@components/LocalMerchant/Case/constant'

@observer
class MenuItem extends Component {
  render() {
    const { merchant_category_id } = this.props.store
    const { item } = this.props
    const canEdit =
      item.id != MENU_ALL && item.id != MENU_NOT_CLASSIFY && !isSiDaMember()
    return (
      <li
        className={cls(
          style.menuItem,
          merchant_category_id == item.id ? style.active : ''
        )}
        onClick={() =>
          this.props.store.setStoreData('merchant_category_id', item.id, true)
        }
      >
        {`${item.title}(${item.itemCount || 0})`}
        {canEdit && (
          <EditOutlined
            className={style.edit}
            onClick={e => this.props.editCaseCate(e, item)}
          />
        )}
      </li>
    )
  }
}

export default MenuItem
